import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function ReferralTerms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        {/* Prevent search engine indexing */}
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        <title>Terms & Conditions - Referral Cashback Offer - Lunar Electric</title>
        <meta name="description" content="Terms and conditions for the Lunar Electric referral cashback program" />
      </Helmet>

      <div style={{ 
        fontFamily: "'Poppins', sans-serif", 
        minHeight: '100vh', 
        backgroundColor: '#f5f5f5',
        padding: '2rem 1rem'
      }}>
        <div style={{ 
          maxWidth: '900px', 
          margin: '0 auto', 
          backgroundColor: 'white',
          padding: '3rem',
          borderRadius: '10px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          <h1 style={{ 
            color: '#1F3A93', 
            fontSize: '2.5rem',
            marginBottom: '1rem',
            textAlign: 'center'
          }}>
            Terms & Conditions
          </h1>
          <p style={{ 
            textAlign: 'center', 
            color: '#666', 
            marginBottom: '3rem',
            fontSize: '1.1rem'
          }}>
            Referral Cashback Program
          </p>

          <div style={{ lineHeight: '1.8', color: '#333' }}>
            
            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                1. Program Overview
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                This Referral Cashback Program ("Program") is offered by Lunar Electric ("Company", "we", "us", "our") to encourage existing customers and interested parties to refer friends and family members for solar panel installations. By participating in this Program, you agree to be bound by these Terms & Conditions.
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                2. Eligibility
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                To be eligible for the cashback:
              </p>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li>You must be a resident of India and at least 18 years of age</li>
                <li>The referred party must be a new customer (not an existing customer of Lunar Electric)</li>
                <li>The referred installation must be completed and verified by Lunar Electric</li>
                <li>You must have a valid bank account in India for cashback payment</li>
                <li>Employees of Lunar Electric and their immediate family members are not eligible to participate</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                3. Cashback Structure
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                The cashback amount is based on the installed solar system capacity:
              </p>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li><strong>3–5 kW:</strong> ₹10,000 cashback</li>
                <li><strong>5–8 kW:</strong> ₹20,000 cashback</li>
                <li><strong>8–10 kW:</strong> ₹30,000 cashback</li>
                <li><strong>10 kW and above:</strong> ₹40,000 cashback</li>
              </ul>
              <p style={{ marginBottom: '1rem', fontStyle: 'italic', color: '#666' }}>
                Note: The system capacity is determined by the final installed capacity as verified by Lunar Electric.
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                4. Cashback Payment Process
              </h2>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li>Cashback will be processed only after successful completion, commissioning, and verification of the referred installation</li>
                <li>Verification includes, but is not limited to, confirmation of installation completion, system testing, and customer satisfaction</li>
                <li>Payment will be made via bank transfer to the bank account details provided by the referrer</li>
                <li>Cashback will be credited within 30-45 business days after verification</li>
                <li>The referrer is responsible for providing accurate bank account details. Any errors in payment details may delay the cashback</li>
                <li>All applicable taxes (TDS, GST, etc.) as per Indian laws will be deducted before payment</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                5. Referral Process
              </h2>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li>The referral must be made before the referred party enters into any agreement with Lunar Electric</li>
                <li>The referred party must mention the referrer's name and contact details during the initial inquiry</li>
                <li>Referrals cannot be retroactively applied to existing customers or ongoing projects</li>
                <li>Multiple referrals are allowed, and cashback will be provided for each eligible referral</li>
                <li>Self-referrals or referrals to oneself are not permitted</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                6. Limitations and Restrictions
              </h2>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li>The Program is valid only for referrals made during the promotional period as specified by Lunar Electric</li>
                <li>Lunar Electric reserves the right to modify, suspend, or terminate the Program at any time without prior notice</li>
                <li>Cashback is not transferable, assignable, or redeemable for cash in advance</li>
                <li>In case of cancellation of the referred installation by the customer, no cashback will be provided</li>
                <li>In case of disputes, the decision of Lunar Electric shall be final and binding</li>
                <li>Fraudulent activities, misrepresentation, or violation of these terms will result in immediate disqualification</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                7. Compliance with Indian Laws
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                This Program complies with applicable Indian laws including:
              </p>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li><strong>Consumer Protection Act, 2019:</strong> All participants are protected under consumer protection laws</li>
                <li><strong>Income Tax Act, 1961:</strong> Cashback amounts may be subject to tax deductions as per applicable tax laws</li>
                <li><strong>GST Act:</strong> Goods and Services Tax will be applicable as per prevailing rates</li>
                <li><strong>Contract Act, 1872:</strong> These terms constitute a valid contract between the participant and Lunar Electric</li>
              </ul>
              <p style={{ marginBottom: '1rem' }}>
                All cashback payments are subject to:
              </p>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li>Tax Deduction at Source (TDS) as applicable under Section 194A or relevant sections of the Income Tax Act, 1961</li>
                <li>Compliance with Know Your Customer (KYC) requirements as per Indian banking regulations</li>
                <li>Furnishing of PAN card details for transactions above the threshold limit</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                8. Data Privacy
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                By participating in this Program, you consent to:
              </p>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li>Collection and processing of your personal information as per our Privacy Policy</li>
                <li>Sharing of information with third-party service providers necessary for cashback processing</li>
                <li>Use of your information for program-related communications</li>
              </ul>
              <p style={{ marginBottom: '1rem' }}>
                Your data will be handled in compliance with the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011.
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                9. Disclaimers and Warranties
              </h2>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li>Lunar Electric makes no warranties, expressed or implied, regarding the Program</li>
                <li>The Program is provided "as is" and "as available" without warranties of any kind</li>
                <li>Lunar Electric is not liable for any indirect, incidental, or consequential damages arising from participation in the Program</li>
                <li>Solar installations are subject to site feasibility, technical assessments, and regulatory approvals</li>
                <li>Cashback is subject to the successful completion of all installation requirements</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                10. Dispute Resolution
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Any disputes arising out of or in connection with this Program shall be subject to:
              </p>
              <ul style={{ paddingLeft: '2rem', marginBottom: '1rem' }}>
                <li>First, good faith attempts to resolve disputes through direct communication with Lunar Electric</li>
                <li>If unresolved, disputes shall be subject to the exclusive jurisdiction of courts in the city where Lunar Electric's registered office is located</li>
                <li>The governing law for these terms shall be the laws of India</li>
                <li>Alternative dispute resolution mechanisms as per the Arbitration and Conciliation Act, 2015 may be used</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                11. Force Majeure
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Lunar Electric shall not be liable for any failure to perform its obligations under this Program due to circumstances beyond its reasonable control, including but not limited to natural disasters, pandemics, government actions, or other force majeure events.
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                12. Modifications to Terms
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Lunar Electric reserves the right to modify these Terms & Conditions at any time. Continued participation in the Program after such modifications constitutes acceptance of the updated terms. Participants are advised to review these terms periodically.
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ color: '#1F3A93', fontSize: '1.5rem', marginBottom: '1rem' }}>
                13. Contact Information
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                For any queries, clarifications, or complaints regarding this Program, please contact:
              </p>
              <div style={{ 
                backgroundColor: '#f8f9fa', 
                padding: '1.5rem', 
                borderRadius: '5px',
                marginBottom: '1rem'
              }}>
                <p style={{ marginBottom: '0.5rem' }}>
                  <strong>Lunar Electric</strong><br />
                  Email: <a href="mailto:ronak@lunarelectric.in" style={{ color: '#1F3A93' }}>ronak@lunarelectric.in</a><br />
                  Phone: <a href="tel:+919148857417" style={{ color: '#1F3A93' }}>+91 9148857417</a>
                </p>
              </div>
            </section>

            <section style={{ 
              marginBottom: '2rem',
              padding: '1.5rem',
              backgroundColor: '#fff3cd',
              borderRadius: '5px',
              border: '1px solid #ffc107'
            }}>
              <h2 style={{ color: '#856404', fontSize: '1.3rem', marginBottom: '1rem' }}>
                Important Notice
              </h2>
              <p style={{ color: '#856404', marginBottom: '1rem' }}>
                By participating in this Referral Cashback Program, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, please do not participate in the Program.
              </p>
              <p style={{ color: '#856404', marginBottom: '0' }}>
                This Program is governed by Indian laws and is subject to the exclusive jurisdiction of Indian courts. All disputes will be resolved in accordance with Indian legal procedures.
              </p>
            </section>

            <div style={{ 
              textAlign: 'center', 
              marginTop: '3rem',
              paddingTop: '2rem',
              borderTop: '2px solid #e0e0e0'
            }}>
              <p style={{ color: '#666', marginBottom: '1rem' }}>
                Last Updated: {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
              <Link 
                to={`/referral${window.location.search}`}
                style={{
                  color: '#1F3A93',
                  textDecoration: 'none',
                  fontSize: '1.1rem',
                  fontWeight: '600'
                }}
              >
                ← Back to Referral Page
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReferralTerms;

